import { useClickOutside } from "@/lib/hooks/useClickOutside";
import { PropsWithChildren, useRef } from "react";
import { Header, Indicator, Label, Menu } from "./styles";

type Props = PropsWithChildren<{
  label: string;
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}>;

const Dropdown: React.FC<Props> = (props) => {
  const { label, children, isOpen, handleOpen, handleClose } = props;
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => isOpen && handleClose());

  return (
    <div ref={ref}>
      <Header onClick={() => (isOpen ? handleClose() : handleOpen())}>
        <Label>{label}</Label>
        <Indicator />
      </Header>
      {isOpen && <Menu>{children}</Menu>}
    </div>
  );
};

export default Dropdown;
